var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.tip)?_c('div',{staticClass:"tip",domProps:{"textContent":_vm._s(_vm.tip)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }